import { useSyncExternalStore } from 'react';

import { $$api } from '@doger/core/shared/api';

export const useJWTTokens = () => {
  const tokens = useSyncExternalStore(
    (fn) => {
      const unsubscribe = [
        $$api.tokensService.onTokensUpdated(fn),
        $$api.tokensService.onTokensRemoved(fn),
      ];

      return () => {
        unsubscribe.forEach((unsubscribe) => unsubscribe());
      };
    },
    (): string | null => {
      const tokens = $$api.tokensService.getTokens();

      if (!tokens.accessToken || !tokens.refreshToken) {
        return null;
      }

      return `${tokens.accessToken}|${tokens.refreshToken}`;
    },
    (): string | null => {
      const tokens = $$api.tokensService.getTokens();

      if (!tokens.accessToken || !tokens.refreshToken) {
        return null;
      }

      return `${tokens.accessToken}|${tokens.refreshToken}`;
    }
  );

  if (!tokens) {
    return { accessToken: null, refreshToken: null };
  }

  const [accessToken, refreshToken] = tokens.split('|');

  return { accessToken, refreshToken };
};
